import { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { updateSubscriptionTier } from '../../actions'
import { accessStripeCustomerPortal, requestProfile, saveIsSelfEmployed } from './actions'
import profileSelector, { getOrderedSubscriptions } from './selectors'

/**
 * @deprecated
 */
export const useProfile = () => {
    const dispatch = useDispatch()

    const profile = useSelector(profileSelector)
    const subscriptions = useSelector(getOrderedSubscriptions)
    const { shouldFetch } = profile

    const shouldPreventFetch = !shouldFetch || !profile.id

    useEffect(() => {
        if (shouldPreventFetch) return
        dispatch(requestProfile())
    }, [dispatch, shouldPreventFetch])

    return {
        ...profile,
        subscriptions,
    }
}

/**
 * @deprecated
 */
export const useProfileActions = () => {
    const dispatch = useDispatch()

    return useMemo(
        () => ({
            accessStripeCustomerPortal: (...args) => dispatch(accessStripeCustomerPortal(...args)),
            requestProfile: (...args) => dispatch(requestProfile(...args)),
            saveIsSelfEmployed: (...args) => dispatch(saveIsSelfEmployed(...args)),
            updateSubscriptionTier: (data) => updateSubscriptionTier(dispatch, data),
        }),
        [dispatch]
    )
}
